import request from '@/router/axios';

const getList = (current, size, params) => request({
  url: '/api/mcc-staff/leaverecord/page',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})
const vacationCreditDetail = (current, size, params) => request({
  url: '/api/mcc-staff/vacationCreditDetail/search',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})
const vacationCreditUpdate = params => request({
  url: '/api/mcc-staff/vacationCreditDetail/update',
  method: 'post',
  data: params,
})

const add = params => request({
  url: '/api/mcc-staff/leaverecord/save',
  method: 'post',
  data: params,
})

const detail = params => request({
  url: '/api/mcc-staff/leaverecord/detail',
  method: 'get',
  params: {
    ...params,
  },
})

const update = params => request({
  url: '/api/mcc-staff/leaverecord/update',
  method: 'post',
  data: params,
})

const remove = ids => request({
  url: '/api/mcc-staff/leaverecord/remove',
  method: 'post',
  params: {
    ids,
  },
})

const downLoadExcel = params => request({
  url: '/api/mcc-staff/leaverecord/excel',
  method: 'get',
  responseType: 'blob',
  params: {
    ...params,
  },
})

export default {
  getList,
  add,
  detail,
  update,
  remove,
  downLoadExcel,
  vacationCreditDetail,
  vacationCreditUpdate
};
